import type { FC } from 'react';
import React, { useState } from 'react';
import { FormInput } from '@alfa-bank/site-form-input';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
import { StaticActions as actions } from '@alfa-bank/site-form-utils/actions';

import type { TBonusCard, TBonusCardState } from './models';

export const BonusCard: FC<TBonusCard> = ({
    RadioTags,
    Text,
    config,
    hasNewBonusCardDesign = false,
    inputText,
    questionText,
}) => {
    const [isBonusCard, setIsBonusCard] = useState<TBonusCardState>('hidden');

    if (!questionText) {
        return null;
    }

    return (
        <div data-test-id="bonusCard">
            {hasNewBonusCardDesign && (
                <Text
                    data-test-id="bonusNumberTag-caption"
                    styler={{
                        marginTop: 0,
                        marginBottom: 12,
                    }}
                    view={config.textView}
                >
                    {questionText}
                </Text>
            )}
            <Field
                name="bonusNumberTag"
                render={({ input, meta }) => (
                    <RadioTags
                        caption={hasNewBonusCardDesign ? '' : questionText}
                        name="bonusNumberTag"
                        onSelect={({ value }) => {
                            actions.onChange(input, meta)(value);
                            setIsBonusCard(value as TBonusCardState);
                        }}
                        selected={isBonusCard}
                        size="xs"
                        styler={{ paddingBottom: 24 }}
                        tags={[
                            {
                                label: 'Да',
                                value: 'visible',
                            },
                            {
                                label: 'Нет',
                                value: 'hidden',
                            },
                        ]}
                    />
                )}
            />

            {isBonusCard === 'visible' && (
                <FormInput
                    isRequired
                    name="bonusNumber"
                    settings={{
                        accept: '^\\d{1,10}$',
                        placeholder: inputText,
                    }}
                    styler={{ paddingBottom: 24 }}
                />
            )}
        </div>
    );
};
